import { apiCall, ApiResponse } from "./apiClient";
import {
    TransportPlanDetailsDto,
    TransportPlanListItemDto,
    TransportPlanListQueryParameters, TransportPlanState,
} from "../models/transport/transportPlan";
import { TransportOrTransportPlan } from "../models/transport/transport";

export const getTransportPlans = (
    params: TransportPlanListQueryParameters,
    signal: AbortSignal
) => {
    return apiCall<TransportPlanListItemDto[]>(
        "TransportPlans",
        "GET",
        params,
        signal
    );
};

export const fetchTransportPlans = (filters: any): Promise<ApiResponse<TransportPlanListItemDto[]>> => {
    return apiCall<TransportPlanListItemDto[]>("TransportPlans", "GET", filters);
};

export const fetchTransportPlan = (id: string): Promise<ApiResponse<TransportPlanDetailsDto>> => {
    return apiCall<TransportPlanDetailsDto>(`TransportPlans/${id}`, "GET");
};

export const updateTransportPlanState = (id: string, newState: TransportPlanState): Promise<ApiResponse<void>> => {
    return apiCall<void>(`TransportPlans/${id}/State/${newState}`, "PUT");
};

// Since DTOs return differing data, normalize them using this model
export const transportPlanToCommonTransportModel = (data: TransportPlanListItemDto) : TransportOrTransportPlan => {
    return {
        transportPlanId: data.id,
        transportId: data.transportId,
        name: data.name,
        transportPlanState: data.state,
        orders: data.orders,
        employee: data.employee,
        vehicle: data.vehicle,
        plan: data,
        startDateTime: data.scheduledStartDateTime,
        endDateTime: data.scheduledEndDateTime,
        isPlan: data.transportId === null,
    };
};
